
export const camelToKebabCase = (str: string): string => {
    return str.split("").map((letter, idx) => {
        return letter.toUpperCase() === letter
            ? `${idx !== 0 ? "-" : ""}${letter.toLowerCase()}`
            : letter;
    }).join("");
};
